'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMenuContainerSize = exports.setUserNavigationType = exports.setMobileNavigation = exports.keyboardToggleCart = exports.toggleMenuItemOpen = exports.closeMainMenu = exports.toggleMenuOpen = exports.closeHeaderSearch = exports.togglemenuLevels = exports.toggleHeaderSearch = exports.setNewJoke = exports.isMobile = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// cursors blink time
var blinkTime = 400;
// Time it takes to delete/type a letter
var typeTime = {
  min: 25,
  max: 50
};

// timer for tracking the joke animation
var cursorTimer = null;

// Remove a letter from the joke. If there are letters left, set a timeout
// to remove another, otherwise set to display a new joke
var removeLetter = function removeLetter(container) {
  var currentMessage = container.textContent;
  var newMessage = currentMessage.slice(0, currentMessage.length - 1);
  container.textContent = newMessage;
  container.classList.remove('windows-topbar__animation');
  if (0 < newMessage.length) {
    setTimeout(function () {
      removeLetter(container);
    }, getTimeoutTime());
  } else {
    var newJoke = getNewJoke(container);
    setTimeout(function () {
      addLetter(container, newJoke);
    }, getTimeoutTime());
  }
};

// Add a letter for the new joke, and set a timeout to add a new letter
var addLetter = function addLetter(container, joke) {
  var currentJoke = container.textContent;
  var nextLetter = joke[currentJoke.length];
  container.innerHTML = joke;
  container.classList.add('windows-topbar__animation');
  container.style = '--n:' + joke.length;
  cleanupJokeAnimation(container);
};

// clean up intervals and animation classes
var cleanupJokeAnimation = function cleanupJokeAnimation(container) {
  container.classList.remove('cursor', 'blinked');
  clearInterval(cursorTimer);
  cursorTimer = null;
};

// want to slightly randomize the time to animate typing each character
var getTimeoutTime = function getTimeoutTime() {
  return Math.floor(Math.random() * (typeTime.max - typeTime.min) + typeTime.min);
};

// Get a new joke to display to the customer
// Jokes should be displayed in the order they are in the customizer
var getNewJoke = function getNewJoke(container) {
  var maxJokeOn = jokesArray.length - 1;
  var jokeOn = container.hasAttribute('data-joke-on') ? parseInt(container.dataset.jokeOn, 10) : 0;
  var newJokeOn = jokeOn < maxJokeOn ? jokeOn + 1 : 0;
  container.dataset.jokeOn = newJokeOn;

  return jokesArray[newJokeOn];
};

var closeAllMenuItems = function closeAllMenuItems(currentMenuItem) {
  var menuItems = document.querySelectorAll(_Dom2.default.menuItemTrigger);
  menuItems.forEach(function (item) {
    item != currentMenuItem && item.classList.remove('open');
  });
};

var setMenuIcons = function setMenuIcons() {
  var menu = document.querySelector('[mobile-menu-container]');
  var close = document.querySelector('[data-menu-is-closed]');
  var open = document.querySelector('[data-menu-is-open]');
  var isOpen = menu.classList.contains('open');

  close.style.display = isOpen ? 'none' : 'flex';
  open.style.display = isOpen ? 'flex' : 'none';
};

var preventBodyScroll = function preventBodyScroll() {
  var body = document.body;
  var menu = document.querySelector('[mobile-menu-container]');
  var isOpen = menu.classList.contains('open');

  body.style.overflow = isOpen ? 'hidden' : 'auto';
};

// ensure that the first child menu is selected
var openFirstMenuItem = function openFirstMenuItem() {
  var firstChildMenu = document.querySelector('[data-default-dropdown]');
  setMobileNavigation({ event: { target: firstChildMenu } });
};

var isMobile = exports.isMobile = function isMobile() {
  return window.innerWidth <= 1050;
};

// Callback for the new jokes event
var setNewJoke = exports.setNewJoke = function setNewJoke(data) {
  if (null == cursorTimer) {
    var jokesContainer = document.querySelector('[data-joke-container]');
    jokesContainer.classList.add('cursor');
    removeLetter(jokesContainer);
    // set an interval for making the cursor "blink"
    cursorTimer = setInterval(function () {
      jokesContainer.classList.toggle('blinked');
    }, blinkTime);
  }
};

var toggleHeaderSearch = exports.toggleHeaderSearch = function toggleHeaderSearch(data) {
  var searchElement = document.querySelector(_Dom2.default.navigationSearch);
  searchElement.classList.toggle('open');
  document.querySelector('.windows-form__input.windows-form__text').focus();
};

var togglemenuLevels = exports.togglemenuLevels = function togglemenuLevels(data) {
  var triggers = document.querySelectorAll(_Dom2.default.menuLevelTrigger);
  triggers.forEach(function (trigger) {
    var child = trigger.querySelector(_Dom2.default.menuLevelContent);
    trigger.addEventListener('click', function (e) {
      child.style.left = 0;
    });
    var btnBack = child.querySelector(_Dom2.default.menuLevelClose);
    btnBack.addEventListener('click', function (e) {
      e.stopPropagation();
      child.removeAttribute('style');
    });
  });
};

var closeHeaderSearch = exports.closeHeaderSearch = function closeHeaderSearch(data) {
  var searchElement = document.querySelector(_Dom2.default.navigationSearch);
  searchElement.classList.remove('open');
  // fix for iOS hiding all other of the same SVG
  var jokeButton = document.querySelector(_Dom2.default.joke);
  jokeButton.style.display = 'inline-block';
  // if we're in the mobile menu, open up the first menu item
  isMobile() && openFirstMenuItem();
};

var toggleMenuOpen = exports.toggleMenuOpen = function toggleMenuOpen(data) {
  var menu = document.querySelector('[mobile-menu-container]');
  if (menu.classList.contains('open')) {
    var levels = document.querySelectorAll(_Dom2.default.menuLevelContent);
    levels.forEach(function (level) {
      level.removeAttribute('style');
    });
  }
  menu.classList.toggle('open');
  openFirstMenuItem();
  setMenuIcons();
  preventBodyScroll();
};

var openSearch = function openSearch() {
  // searchElement.addEventListener('click', () => {
  //   searchElement.classList.toggle('open');
  // })
};

var closeMainMenu = exports.closeMainMenu = function closeMainMenu(data) {
  var menu = document.querySelector('[mobile-menu-container]');
  menu.classList.remove('open');
  // also make sure sub menus are closed
  closeAllMenuItems();
  setMenuIcons();
};

// Add some basic keyboard navigation to the menu
var toggleMenuItemOpen = exports.toggleMenuItemOpen = function toggleMenuItemOpen(data) {
  var keyCode = data.event.keyCode;
  var enterKeyCode = 13;
  var escapeKeyCode = 27;
  var menuItem = data.event.target;
  menuItem.setAttribute('aria-expanded', 'true')
  // need to ensure other menus aren't also open at the same time
  [(enterKeyCode, escapeKeyCode)].includes(keyCode) && closeAllMenuItems(menuItem);
  // perform toggling by using classes
  keyCode == enterKeyCode && menuItem.classList.toggle('open');
  keyCode == escapeKeyCode && menuItem.classList.remove('open');
};

var keyboardToggleCart = exports.keyboardToggleCart = function keyboardToggleCart(data) {
  var keyCode = data.event.keyCode;
  var enterKeyCode = 13;
  if (keyCode == enterKeyCode) {
    closeAllMenuItems(null);
    PubSub.publish(_Constants2.default.toggleInlineCart);
  }
};

var setMobileNavigation = exports.setMobileNavigation = function setMobileNavigation(data) {
  var mainMenu = document.querySelector('[mobile-menu-container]');
  mainMenu.scrollTop = 0;
};

// If the user is a keyboard user, make sure they have the
// outlines for where the focus is (don't want it for mouse users)
var setUserNavigationType = exports.setUserNavigationType = function setUserNavigationType(data) {
  var keyCode = data.event.keyCode;
  var tabKeyCode = 9;
  var header = document.querySelector('[data-header-wrapper]');
  keyCode == tabKeyCode && header.classList.remove('mouse-navigation');
};

var setMenuContainerSize = exports.setMenuContainerSize = function setMenuContainerSize(data) {
  var navContainer = document.querySelector(_Dom2.default.menuContainer);
  var screenHeight = window.innerHeight;
  navContainer.style.height = 'calc(' + screenHeight + 'px - 100%)';
};

togglemenuLevels();
openSearch();